import React, { useEffect, useState } from 'react'
import Layout from './Layout'
import countassest from '../../../../assets/theme6/count.svg'
import Style from './startNewChallenge.module.scss'
import CountAnimation from '../Animation/countAnimation'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import PlayPart from './PlayPart'
import QuizWallYellow from '../../../../assets/svg/QuizWallYellow'


const StartNewChallenge = ({qnaData,isLogo=true ,chId}) => {
    const search = useLocation().search;
    const mission_id = new URLSearchParams(search).get('mission_id');
    const [count, setCount] = useState(3)
   
    useEffect(() => {
        const handleBeforeUnload = (event) => {
          event.preventDefault();
          alert("hello world")

        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
          window.removeEventListener('beforeunload', handleBeforeUnload);
        };
      }, []);

    useEffect(() => {
        const intervalId = setInterval(() => {
            if (count > 0) {
                setCount(count - 1); // Decrease count by 1
            }else {
                clearInterval(intervalId); // Clear the interval when count reaches 1
            }
        }, 1000); // Repeat every 1000 milliseconds (1 second)

        // Clean up the interval when the component unmounts
        return () => clearInterval(intervalId);
    }, [count]);

    useEffect(() => {
       

        window.location.hash ="no-back-button";
            window.location.hash = "Again-No-back-button";
            window.onhashchange = function () {
                window.location.hash = "no-back-button";
            }
        
    }, [])

   

    return (
        <>
            <Layout missionId={mission_id} isLogo={isLogo} isFLexNeed={true}>
                <div className={Style.logo_section}><QuizWallYellow/></div>
                <div className={Style.container}>
                   {count!=0?
                   <div className={Style.count__div}>
                        <div className={Style.count__number}>
                            {count<4 && count}
                        </div>

                        <img src={countassest} alt="count" />
                        <div className={Style.animation}>
                           {count<4 && <CountAnimation />}

                        </div>
                    </div>:
                    <PlayPart time_criteria={qnaData?.missionQuestion?.time_criteria} qnaData={qnaData} chId={chId}/>}
                </div>

           {/* {showPopup && <ExitPopup2 state={showPopup} setState={setShowPopup}/>} */}

            </Layout>
        </>
    )
}

export default StartNewChallenge;  
  